import React, { useEffect, useState } from 'react';
import {
   Grid,
   MenuItem,
   IconButton,
   Toolbar,
   AppBar,
   Typography,
   TextField,
   Divider,
   Avatar,
   makeStyles,
} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import { useStyles } from './styles';
import clsx from 'clsx';
import { ClassNameMap } from '@material-ui/styles';
import DateTime from '../DateTime';
import { useHistory, useLocation } from 'react-router-dom';
import { Theme, useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/styles';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuList from '@material-ui/core/MenuList';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Logo from '../../resources/images/logo-automedsys.png';
import { faBell, faCaretDown, faEllipsisV, faSearch, faUser, faUserPlus } from '@fortawesome/free-solid-svg-icons';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Formik } from 'formik';

interface searchListProps {
   value: string;
   label: string;
}
interface searchFilterProps {
   label: string;
   lists: Array<searchListProps>;
   action: (value: string) => void;
}
const useHeaderStyles = makeStyles((theme) => ({
   root: {
      backgroundColor: theme.palette.background.paper,
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create(['width', 'margin'], {
         easing: theme.transitions.easing.sharp,
         duration: theme.transitions.duration.leavingScreen,
      }),
      borderBottom: '1px solid gainsboro',
      boxShadow: 'none',
   },
}));

const Header = (props: any) => {
   const classes: ClassNameMap = useStyles();
   const headerClasses: ClassNameMap = useHeaderStyles();
   const [anchorEl, setAnchorEl] = useState(null);
   const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);
   const isMenuOpen = Boolean(anchorEl);
   const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
   const anchorRef = React.useRef<HTMLButtonElement>(null);
   const [open, setOpen] = useState(false);
   const [searchFilter, setSearchFilter] = useState<searchFilterProps>({
      label: props.searchFilters[0].label,
      lists: props.searchFilters[0].lists,
      action: props.searchFilters[0].action,
   });
   const [value, setValue] = React.useState<string | any>('');
   const [inputValue, setInputValue] = React.useState('');
   const theme: Theme = useTheme();
   const isDesktop = useMediaQuery(theme.breakpoints.up('lg'), {
      defaultMatches: true,
   });
   const isMobile = useMediaQuery(theme.breakpoints.down('sm'), {
      defaultMatches: true,
   });

   const isXs = useMediaQuery(theme.breakpoints.down('xs'), {
      defaultMatches: true,
   });
   const history = useHistory();
   const location = useLocation();

   const handleProfileMenuOpen = (event: any) => {
      setAnchorEl(event.currentTarget);
   };

   const handleMobileMenuClose = () => {
      setMobileMoreAnchorEl(null);
   };

   const handleMenuClose = () => {
      setAnchorEl(null);
      handleMobileMenuClose();
   };

   const signOut = () => {
      setAnchorEl(null);
      handleMobileMenuClose();
      sessionStorage.clear();
      history.push('/');
   };

   const viewNotifications = () => {
      history.push('/notifications');
   };

   const viewProfile = () => {
      history.push('/profile');
   };

   const addPatient = () => {
      history.push('/patient/newPatient');
   };

   const searchPatient = () => {
      history.push('/patient');
   };

   useEffect(() => {
      setSearchFilter(props.searchFilters[0]);
   }, [props.searchFilters]);

   useEffect(() => {
      const searchFilterObj = props.searchFilters.find(
         (filter: Record<string, any>) => filter.route === location.pathname,
      );
      searchFilterObj && setSearchFilter(searchFilterObj);
   }, [location.pathname, location.state]);

   const handleMobileMenuOpen = (event: any) => {
      setMobileMoreAnchorEl(event.currentTarget);
   };

   const handleToggle = () => {
      setOpen((prevOpen) => !prevOpen);
   };

   const handleClose = (event: React.MouseEvent<EventTarget>) => {
      if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
         return;
      }

      setOpen(false);
   };

   function handleListKeyDown(event: React.KeyboardEvent) {
      if (event.key === 'Tab') {
         event.preventDefault();
         setOpen(false);
      }
   }

   const ArrowDownIcon = <FontAwesomeIcon icon={faCaretDown} className={classes.icon} color="black" />;

   const menuId = 'primary-search-account-menu';
   const renderMenu = (
      <>
         <Popper open={isMenuOpen} anchorEl={anchorEl} role={undefined} transition disablePortal style={{ zIndex: 9 }}>
            {({ TransitionProps, placement }) => (
               <Grow {...TransitionProps} style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'bottom' }}>
                  <Paper style={{ width: isXs ? '150px' : '230px', boxShadow: 'none' }}>
                     <ClickAwayListener onClickAway={handleMenuClose}>
                        <MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                           <MenuItem>
                              {props.user.name}
                              <br />({props.user.practiseName})
                           </MenuItem>
                           {/* <MenuItem></MenuItem> */}
                           <Divider />
                           <MenuItem onClick={viewProfile}>Profile</MenuItem>
                           {/* <MenuItem onClick={handleMenuClose}>My account</MenuItem> */}
                           <MenuItem onClick={signOut}>Sign out</MenuItem>
                        </MenuList>
                     </ClickAwayListener>
                  </Paper>
               </Grow>
            )}
         </Popper>
      </>
   );

   const mobileMenuId = 'primary-search-account-menu-mobile';
   const renderMobileMenu = (
      <Popper
         open={isMobileMenuOpen}
         anchorEl={mobileMoreAnchorEl}
         role={undefined}
         transition
         disablePortal
         style={{ zIndex: 9 }}
      >
         {({ TransitionProps, placement }) => (
            <Grow {...TransitionProps} style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'bottom' }}>
               <Paper style={{ width: '230px', boxShadow: 'none' }}>
                  <ClickAwayListener onClickAway={handleMobileMenuClose}>
                     <Autocomplete
                        id="combo-box-demo"
                        options={searchFilter.lists}
                        getOptionLabel={(option) => (option.label ? option.label : '')}
                        value={value}
                        onChange={(event: any, newValue: string | null) => {
                           const option = searchFilter.lists.find((option: any) => option.label === newValue);
                           option && searchFilter.action(option.value);
                           setValue(newValue);
                        }}
                        inputValue={inputValue}
                        onInputChange={(event, newInputValue) => {
                           const option = searchFilter.lists.find((option: any) => option.label === newInputValue);
                           option && searchFilter.action(option.value);
                           setInputValue(newInputValue);
                        }}
                        style={{ width: '100%' }}
                        renderInput={(params) => (
                           <TextField
                              {...params}
                              className={clsx(classes.outline, classes.shiftRight)}
                              placeholder="Search"
                              variant="outlined"
                              margin="dense"
                           />
                           // <TextField
                           //    {...params}
                           //    className={clsx(classes.outline, classes.shiftRight)}
                           //    placeholder="Search"
                           //    // value={props.value}
                           //    margin="dense"
                           //    // style={{ width: '100%' }}
                           //    // onChange={props.onChange}
                           //    variant="outlined"
                           // />
                        )}
                     />
                  </ClickAwayListener>
               </Paper>
            </Grow>
         )}
      </Popper>
   );

   const renderSearchOptions = (
      <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal style={{ zIndex: 9 }}>
         {({ TransitionProps, placement }) => (
            <Grow {...TransitionProps} style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'bottom' }}>
               <Paper style={{ width: 'auto', boxShadow: 'none' }}>
                  <ClickAwayListener onClickAway={handleClose}>
                     <MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                        {props.searchFilters.map((filter: searchFilterProps, index: number) => {
                           return (
                              <MenuItem
                                 key={index}
                                 onClick={() => {
                                    setSearchFilter(filter);
                                    setOpen(false);
                                 }}
                              >
                                 {filter.label}
                              </MenuItem>
                           );
                        })}
                     </MenuList>
                  </ClickAwayListener>
               </Paper>
            </Grow>
         )}
      </Popper>
   );

   return (
      <div>
         <AppBar classes={headerClasses} position="fixed" color="secondary">
            <Toolbar variant="dense">
               {isMobile ? (
                  <IconButton color="inherit" aria-label="open drawer" onClick={props.onClick} edge="start">
                     <MenuIcon color="primary" />
                  </IconButton>
               ) : (
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                     <div style={{ width: '180px', height: '50px' }}>
                        <img src={Logo} alt="COMPANY lOGO" style={{ height: '100%', display: 'block' }} />
                     </div>
                  </div>
               )}
               <Grid container xs={12} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <Grid item xs={6} md={7} lg={8}>
                     {isXs ? (
                        <Typography variant="h4" color="primary">
                           autoMedSys
                        </Typography>
                     ) : (
                        <Formik
                           initialValues={{
                              data: '',
                           }}
                           onSubmit={(values, { setSubmitting }) => {
                              searchFilter.action(values.data);
                              setSubmitting(false);
                           }}
                        >
                           {({ handleSubmit, isSubmitting, setFieldValue }) => {
                              return (
                                 <form autoComplete="off" onSubmit={handleSubmit}>
                                    <input name="Username" autoComplete="off" style={{ display: 'none' }} />
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                       {!isMobile && (
                                          <IconButton
                                             style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                width: 'auto',
                                                borderRadius: '5px 0px 0px 5px',
                                             }}
                                             ref={anchorRef}
                                             aria-controls={open ? 'menu-list-grow' : undefined}
                                             aria-haspopup="true"
                                             onClick={handleToggle}
                                             className={classes.iconButton}
                                          >
                                             <Typography style={{ marginRight: '1rem' }}>
                                                {searchFilter.label}
                                             </Typography>
                                             {ArrowDownIcon}
                                          </IconButton>
                                       )}
                                       <Autocomplete
                                          id="combo-box-demo"
                                          options={searchFilter.lists}
                                          getOptionLabel={(option) => (option.label ? option.label : '')}
                                          value={value}
                                          onChange={(event: any, newValue: string | null) => {
                                             const option = searchFilter.lists.find(
                                                (option: any) => option.label === newValue,
                                             );
                                             option && setFieldValue('data', option.value);
                                             // option && searchFilter.action(option.value);
                                             setValue(newValue);
                                          }}
                                          inputValue={inputValue}
                                          onInputChange={(event, newInputValue) => {
                                             const option = searchFilter.lists.find(
                                                (option: any) => option.label === newInputValue,
                                             );
                                             option && setFieldValue('data', option.value);
                                             // option && searchFilter.action(option.value);
                                             setInputValue(newInputValue);
                                          }}
                                          style={{ width: '100%' }}
                                          renderInput={(params) => (
                                             <TextField
                                                {...params}
                                                className={clsx(classes.outline, classes.shiftRight)}
                                                placeholder="Search"
                                                name="search"
                                                id="search"
                                                variant="outlined"
                                                margin="dense"
                                             />
                                          )}
                                       />
                                       <IconButton
                                          aria-label="fullscreen"
                                          className={classes.iconButton}
                                          style={{ borderRadius: '0px 5px 5px 0px' }}
                                          onClick={() => handleSubmit()}
                                          disabled={isSubmitting}
                                       >
                                          <FontAwesomeIcon
                                             icon={faSearch}
                                             style={{ padding: isMobile ? '5px' : '5px 15px' }}
                                             className={classes.icon}
                                             color={theme.palette.primary.main}
                                          />
                                       </IconButton>
                                       {renderSearchOptions}
                                    </div>
                                 </form>
                              );
                           }}
                        </Formik>
                     )}
                  </Grid>
                  <Grid item xs={6} md={5} lg={4}>
                     <div style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center' }}>
                        {isXs ? (
                           <IconButton
                              className={classes.margin}
                              size="medium"
                              aria-label="show more"
                              aria-controls={mobileMenuId}
                              aria-haspopup="true"
                              onClick={handleMobileMenuOpen}
                              color="primary"
                           >
                              <FontAwesomeIcon color={theme.palette.primary.main} icon={faSearch} size="1x" />
                           </IconButton>
                        ) : (
                           <>
                              <IconButton
                                 aria-label="delete"
                                 className={classes.margin}
                                 size="small"
                                 onClick={searchPatient}
                              >
                                 <FontAwesomeIcon color={theme.palette.primary.main} icon={faUser} size="sm" />
                              </IconButton>
                              <IconButton
                                 aria-label="delete"
                                 className={classes.margin}
                                 size="small"
                                 onClick={addPatient}
                              >
                                 <FontAwesomeIcon color={theme.palette.primary.main} icon={faUserPlus} size="sm" />
                              </IconButton>
                           </>
                        )}
                        <IconButton
                           aria-label="delete"
                           className={classes.margin}
                           size={isXs ? 'medium' : 'small'}
                           onClick={viewNotifications}
                        >
                           <FontAwesomeIcon
                              color={theme.palette.primary.main}
                              icon={faBell}
                              size={isXs ? '1x' : 'sm'}
                           />
                        </IconButton>
                        {isXs ? (
                           <Avatar style={{ width: '25px', height: '25px' }} src={props.user.image} />
                        ) : (
                           <IconButton
                              style={{
                                 display: 'flex',
                                 justifyContent: 'space-evenly',
                                 alignItems: 'center',
                                 width: '230px',
                                 border: '1px solid gainsboro',
                                 borderRadius: '3px',
                                 height: '40px',
                                 paddingLeft: '0px',
                                 paddingRight: '0px',
                              }}
                              className={classes.iconButton}
                              size="small"
                              aria-label="account of current user"
                              aria-controls={menuId}
                              aria-haspopup="true"
                              onClick={handleProfileMenuOpen}
                           >
                              <Avatar style={{ width: '20px', height: '20px' }} src={props.user.image} />
                              <Typography style={{ fontWeight: 550, fontSize: '12px', color: 'black' }}>
                                 {`${props.user.name.slice(0, 10)}${props.user.name.length > 10 ? '...' : ''}`}
                              </Typography>
                              {props.user.practiseLogo ? (
                                 <div style={{ width: '100px', height: '30px' }}>
                                    <img
                                       src={props.user.practiseLogo}
                                       alt="COMPANY lOGO"
                                       style={{ height: '100%', display: 'block' }}
                                    />
                                 </div>
                              ) : (
                                 <Typography style={{ fontWeight: 550, fontSize: '12px', color: 'black' }}>
                                    {`${props.user.practiseName.slice(0, 6)}${
                                       props.user.practiseName.length > 6 ? '...' : ''
                                    }`}
                                 </Typography>
                              )}
                           </IconButton>
                        )}
                        {isDesktop ? <DateTime /> : null}
                        {isXs && (
                           <IconButton
                              aria-label="show more"
                              aria-controls={menuId}
                              aria-haspopup="true"
                              onClick={handleProfileMenuOpen}
                              color="primary"
                              size="medium"
                           >
                              <FontAwesomeIcon color={theme.palette.primary.main} icon={faEllipsisV} size="1x" />
                           </IconButton>
                        )}
                     </div>
                  </Grid>
               </Grid>
               {renderMobileMenu}
               {renderMenu}
            </Toolbar>
         </AppBar>
      </div>
   );
};

export default Header;
